import ProfilesSection from '@/views/profiles/ProfilesSection.vue';
import Profiles from '@/views/profiles/Profiles.vue';
import ProfileCreate from '@/views/profiles/ProfileCreate.vue';
import Profile from '@/views/profiles/Profile.vue';
import ProfileDetails from '@/views/profiles/tabs/ProfileDetails.vue';
import ProfileDelete from '@/views/profiles/tabs/ProfileDelete.vue';
import ProfileEdit from '@/views/profiles/tabs/ProfileEdit.vue';
import ProfileAnalytics from '@/views/profiles/tabs/ProfileAnalytics.vue';
import ProfileJWT from '@/views/profiles/tabs/ProfileJWT.vue';

export default [
  {
    path: '/profiles',
    component: ProfilesSection,
    meta: {
      breadcrumb: {
        linkName: 'profiles.index',
        linkText: 'Profiles',
      },
    },
    children: [
      {
        path: '',
        component: Profiles,
        name: 'profiles.index',
      },
      {
        path: 'create',
        component: ProfileCreate,
        name: 'profiles.index.create',
      },
      {
        path: ':id',
        component: Profile,
        meta: {
          breadcrumb: {
            linkName: 'profiles.index.detail',
            linkText: 'Profile Summary',
          },
        },
        children: [
          {
            path: '',
            name: 'profiles.index.detail',
            component: ProfileDetails,
          },
          {
            path: 'analytics',
            name: 'profiles.index.analytics',
            component: ProfileAnalytics,
            props: true,
          },
          {
            path: 'edit',
            name: 'profiles.index.edit',
            component: ProfileEdit,
            props: true,
          },
          {
            path: 'delete',
            name: 'profiles.index.delete',
            component: ProfileDelete,
            props: true,
          },
          {
            path: 'jwt',
            name: 'profiles.index.jwt',
            component: ProfileJWT,
            props: true,
          },
        ],
      },
    ],
  },
];
